<template>
	<div id="purchase" class="position-relative" novalidate>
		<div v-if="cardsLoaded">
			<loader v-if="loading"></loader>
			<div v-if="complete">
				<div>
					<div v-if="plan.key === 'dayPass'" class="success mb-0 p-3" role="alert">
						<h4 class="alert-heading">24 HOUR ACCESS UNLOCKED</h4>
						<p class="mb-0">
							Thanks for your purchase! You're now ready to access all Scoutred has to offer.
						</p>
						<p class="mb-0 mt-3">
							<button v-on:click="routeBack" class="btn btn-green btn-sm">Back</button>
						</p>
					</div>
					<div v-if="plan.key === 'parcelUnlock'" class="success mb-0 p-3" role="alert">
						<h4 class="alert-heading">PARCEL UNLOCKED</h4>
						<p class="mb-0">
							Thanks for your purchase! You're now ready to access all Scoutred has to offer on this parcel.
						</p>
						<p class="mb-0 mt-3">
							<button v-on:click="routeBack" class="btn btn-green btn-sm">Back to Parcel</button>
						</p>
					</div>
					<div v-if="plan.key === 'studio'" class="success mb-0 p-3" role="alert">
						<h4 class="alert-heading">ALL PARCELS UNLOCKED</h4>
						<p class="mb-0">
							Thanks for your purchase! You're now ready to explore all Scoutred has to offer.
						</p>
						<p class="mb-0 mt-3">
							<button v-on:click="routeBack" class="btn btn-green btn-sm">Back to Parcel</button>
						</p>
					</div>					
				</div>
			</div>
			<form v-on:submit.prevent="formSubmit" v-if="!complete">

				<div v-if="token === null" >
					
					<div class="row">
						<div class="col-6 pr-1">
							<div class="form-group mb-0">
								<input type="email" class="form-control" id="loginEmail" 
									v-bind:class="{'is-invalid':error && error.email}" 
									placeholder="Email" v-model="email"/>
								<div class="invalid-feedback">
									{{error && error.email}}
						    </div>
							</div>
						</div>
						<div class="col-6 pl-1">
							<div class="form-group mb-0">
								<input type="password" class="form-control" id="loginPassword" 
									v-bind:class="{'is-invalid':error && (error.password || error.email)}" 
									placeholder="Password" v-model="password"/>
								<div class="invalid-feedback">
									{{error && error.password}}
									<a v-if="error && error.email" href="/users/forgot-password">forget your password?</a>
						    </div>

							</div>
						</div>
					</div>
				</div>
				<div class="" v-if="cards && cards.length > 0">
					<div v-for="(card, index) in cards" v-on:click="selectCard(card.id)" class="px-2 py-2 mb-2 bg-light select-card">
						<div class="form-group mb-0 position-relative">
							<i v-if="card.id === cardOption" class="material-icons radio-btn">radio_button_checked</i>
							<i v-else class="material-icons radio-btn">radio_button_unchecked</i>

							<i class="material-icons md-18 card-icon">credit_card</i>
							<label class="text-16 mb-0">*{{card.last4}}</label>
							<small class="text-muted">EXP {{card.exp_month}}/{{card.exp_year | yearShort}}</small>
							<i v-on:click="cardRemoveToggle(card.id)" class="material-icons md-18 icon-gray close-icon">close</i>
							<a href="javascript:" v-if="cardRemove === card.id" v-on:click="cardRemoveConfirmed(card.id)" 
								class="btn btn-danger btn-sm remove-btn">REMOVE</a>
						</div>
					</div>
					<div v-on:click="selectCard('add')" class="px-2 py-2 bg-light select-card">
						<div class="form-group mb-0">
							<i v-if="cardOption === 'add'" class="material-icons radio-btn">radio_button_checked</i>
							<i v-else class="material-icons radio-btn">radio_button_unchecked</i>
							<i class="material-icons md-18 card-icon">add_box</i>
							<label class="text-16 mb-0">New card</label>
						</div>
					</div>
				</div>
				<div v-if="cardOption === 'add' || (!cards || cards.length < 1)" class="mt-2">
					<div class="form-group mb-0">
						<div class="form-control" v-bind:class="{'is-invalid':error && error.card}">
							<div class="card-mount">
							</div>
						</div>
						<div class="invalid-feedback">
							{{error && error.card}}
				      </div>
					</div>
				</div>
				<div class="mt-2">
					<button class="btn btn-lg btn-dark btn-block" type="submit">PURCHASE</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>

import loader from '../loader';
import config from '../../config';

var stripe = Stripe(config.stripe.publicKey);

export default {
	name: 'unlock-purchase',

	computed:{
		agent: function(){
			return this.$store.state.agent.rec;
		},
		token: function(){
			return this.$store.state.agent.token;
		},
		cards: function(){
			if (!this.$store.state.stripe || !this.$store.state.stripe.customer || !this.$store.state.stripe.customer.sources)
				return null;
			return this.$store.state.stripe.customer.sources.data;
		}
	},
	components:{
		loader
	},
	props: {
		plan:{
			type:Object
		},
		parcel:{
			type:Object
		},
		addressId:{}
	},
	data: function(){
		return {
			email: null,
			password: null,
			card:null,
			loading:true,
			error:null,
			stripeToken:null,
			cardToken:null,
			complete:false,
			cardOption:null,
			cardRemove:null,
			cardFormBound:false,
			cardsLoaded:false
		}
	},
	mounted:function(){
		this.$data.cardsLoaded = true;
		this.$data.loading = false;

		if (!this.cards) return;

		if (this.cards.length > 0){
			this.$data.cardOption = this.cards[0].id;
		}
	},
	updated:function(){
		if (this.$data.cardOption === 'add' || this.$data.cardOption === null) this.bindCardForm();
		else if (this.$data.cardOption !== null){
			this.$data.cardFormBound = false;
		}
	},
   methods: {
		bindCardForm:function(){
			if (this.$data.cardFormBound) return;
			if (this.$data.complete) return;
			var elements = stripe.elements();
			// Custom styling can be passed to options when creating an Element.
			var style = {
				base: {
					// Add your base input styles here. For example:
					fontSize: '16px',
					color: "#495057",
					lineHeight:'26px'
				}
			};

			// Create an instance of the card Element.
			this.$data.card = elements.create('card', {style: style});

			// Add an instance of the card Element into the `card-element` <div>.
			this.$data.card.mount('.card-mount');

			this.$data.cardFormBound = true;
		},
		formSubmit:function(){
			this.$data.loading = true;
			this.clearErrors();
			if (this.token === null){
				if (this.$data.email === null || this.$data.email.length < 1){
					this.formError({email:'enter an email'});
				}
				if (this.$data.password === null || this.$data.password.length < 1){
					this.formError({password:'enter a password'});
				}
				if (this.$data.error !== null) return;
				return this.auth();
			}
			
			if (this.$data.cardToken !== null){
				return this.charge(this.$data.cardToken);
			}
			if (this.$data.cardOption !== null && this.$data.cardOption !== 'add'){
				return this.charge(this.$data.cardOption);
			}
			if (this.$data.cardToken === null && this.$data.stripeToken === null){
				return this.cardSubmit();			
			}
			if (this.$data.cardToken === null && this.$data.stripeToken !== null){
				return this.getCardToken();
			}
		},
		clearErrors:function(err){
			this.$data.error = null;
		},
		formError:function(err){
			this.$data.loading = false;
			this.$data.error = this.$data.error || {};
			for (let i in err){
				this.$data.error[i] = err[i];
			}
		},
		auth:function(){
			this.$store.dispatch('AGENT_LOGIN', {email: this.email, password: this.password, hideError:true}).then(()=>{
				this.formSubmit();
			}).catch((err)=>{
				if (err.response && err.response.status === 401){
					this.$store.dispatch('AGENT_SIGNUP', {email: this.email, password: this.password, hideError:true}).then(()=>{
						this.formSubmit();
					}).catch((err)=>{
						const error = err.response.data.error;
						if (error.indexOf('email') !== -1){ // TODO: handle this with a more robust solution
							return this.formError({email:error});
						}
						this.formError({password:error});
					});
				} else {
					this.formError({password:'invalid login'});
				}
			});
		},
		getCardToken:function(){
			this.$store.dispatch('STRIPE_CARD_TOKEN_GET', {
				stripeToken: this.$data.stripeToken
			}).then((res)=>{
				this.$data.cardToken = res.data.stripeCardId;
				this.formSubmit();
			}).catch((err)=>{
				this.$data.stripeToken = null;
				this.formError({card:'card invalid'});
			});
		},
		charge:function(cardToken){
			if (this.plan.type === 'subscription'){
				this.$store.dispatch('STRIPE_SUBSCRIBE', {
					plan: this.plan.key,
					cardToken: cardToken
				}).then(()=>{
					if (this.plan.ga){
						gtag("event", "purchase", this.plan.ga)
					}

					this.$store.dispatch('PLAN_CURRENT').then(()=>{
						this.$data.complete = true;
						this.$data.loading = false;
						this.routeBack();
					}).catch((err)=>{
						this.formError({card:'get plan error'});
					});
				}).catch((err)=>{
					this.formError({card:'charge error'});
				});
				return;
			}

			this.$store.dispatch('STRIPE_CHARGE', {
				cardToken: cardToken,
				product: 'parcel',
				resourceType: 'parcel',
				resourceId: this.parcel.id
			}).then(()=>{

				if (this.plan.ga){
					gtag("event", "purchase", this.plan.ga)
				}
					
				this.$data.complete = true;
				this.$data.loading = false;
				this.routeBack();
			}).catch((err)=>{
				this.formError({card:'charge error'});
			});
		},
		cardSubmit:function(){
			if (this.$data.card === null) return; // error, card form not defined

			stripe.createToken(this.$data.card).then((result)=>{
				if (result.error) {	
					this.formError({card:result.error.message});
				} else {
					this.$data.stripeToken = result.token;
					this.formSubmit();
				}
			});
		},
		routeBack:function(){
			if (this.$route.query && this.$route.query.next){
				this.$router.push({path:this.$route.query.next});
				return;
			}
			if (window.history.length > 1){
				this.$router.go(-1);
				return;
			}
			if (this.parcel){
				this.$router.push({
					name:'parcel',
					params:{
						id:this.parcel.id
					},
					query:{
						addressId: this.addressId
					}
				});
				return;
			}
			this.$router.push({
				name:'home'
			});
		},
		cardRemoveToggle:function(cardId){
			if (this.$data.cardRemove === cardId) this.$data.cardRemove = null;
			else this.$data.cardRemove = cardId;
		},
		cardRemoveConfirmed:function(cardId){
			this.$data.loading = true;
			if (this.cardOption === cardId){
				this.cardOption = null;
			}
			this.$store.dispatch('STRIPE_CARD_REMOVE', {
				cardId: cardId
			}).then((res)=>{
				this.$data.loading = false;
				if (this.$data.cardOption === cardId){
					this.$data.cardOption = null;
				}
			}).catch((err)=>{
				this.formError({card:'charge error'});
			});
		},
		selectCard:function(cardId){
			this.cardOption = cardId;
		}
	}
}

</script>

<style>
#purchase .field-row{
	font-size:16px;
	line-height:28px;
}
#purchase .success{
	background-color:#DCEDC9;
} 
#purchase h4{font-size:16px;line-height:24px;}
#purchase .radio{margin:0 3px 0 6px;display:inline-block;position:relative;top:-2px;}
#purchase .card-icon{position:relative;top:-2px;}
#purchase .close-icon{position:absolute;right:0;top:4px;}
#purchase .remove-btn{position:absolute;right:24px;top:-4px;}

#purchase .radio-btn{cursor:pointer;opacity:1;position:relative;top:-2px}

#purchase .select-card{cursor:pointer;}
#purchase .select-card:hover{background-color:#FFF !important;}


</style>


// WEBPACK FOOTER //
// src/components/unlock/unlock-purchase.vue